import { render, staticRenderFns } from "./PuntodeVenta2.vue?vue&type=template&id=05252926&scoped=true"
import script from "./PuntodeVenta2.vue?vue&type=script&lang=js"
export * from "./PuntodeVenta2.vue?vue&type=script&lang=js"
import style0 from "./PuntodeVenta2.vue?vue&type=style&index=0&id=05252926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05252926",
  null
  
)

export default component.exports